/**
 * Apps white-label próprios (Flutter) — legado tem 13 marcas mapeadas pra
 * links de App/Play Store, DUPLICADO 6 VEZES em `legacy/fixe-link-2/routes/invite.js`
 * (uma cópia por combinação sucesso/preRegister × Android/iOS). Aqui é uma
 * tabela única de configuração.
 */
export interface WalletFlavor {
  /** Nome do pacote Android — na maioria dos casos é o próprio valor de `hasFlavor`, mas nem sempre (ver bombeef/tradicionalbolos). */
  androidPackageId: string;
  iosUrl: string;
}

export const WALLET_FLAVORS: Record<string, WalletFlavor> = {
  bombeef: {
    androidPackageId: 'com.fixecrm.bombeef.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/o-a%C3%A7ougue-bom-beef/id6499554311',
  },
  'com.fixecrm.tradicionalbolos.wallet.app': {
    androidPackageId: 'com.fixecrm.trbolos.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/tradicional-bolos/id6526488433',
  },
  'com.fixecrm.vipcell.wallet.app': {
    androidPackageId: 'com.fixecrm.vipcell.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/vip-cell/id6738093068',
  },
  'com.fixecrm.clinicahubner.wallet.app': {
    androidPackageId: 'com.fixecrm.clinicahubner.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/clinica-hubner/id6746969489',
  },
  'com.fixecrm.recantodoraspador.wallet.app': {
    androidPackageId: 'com.fixecrm.recantodoraspador.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/recanto-do-raspador/id6746445904',
  },
  'com.fixecrm.omatutochurrascaria.wallet.app': {
    androidPackageId: 'com.fixecrm.omatutochurrascaria.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/o-matuto-churrascaria/id6749178225',
  },
  'com.fixecrm.bubblemix.wallet.app': {
    androidPackageId: 'com.fixecrm.bubblemix.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/bubble-mix/id6749202810',
  },
  'com.fixecrm.teashop.wallet.app': {
    androidPackageId: 'com.fixecrm.teashop.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/tea-shop/id6744371287',
  },
  'com.fixecrm.mrcheney.wallet.app': {
    androidPackageId: 'com.fixecrm.mrcheney.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/mr-cheney-fidelidade/id6744376118',
  },
  'com.fixecrm.emporiobrownie.wallet.app': {
    androidPackageId: 'com.fixecrm.emporiobrownie.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/emporio-brownie-fidelidade/id6755738859',
  },
  'com.fixecrm.drshape.wallet.app': {
    androidPackageId: 'com.fixecrm.drshape.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/dr-shape/id6759007398',
  },
  'com.fixecrm.acaiconcept.wallet.app': {
    androidPackageId: 'com.fixecrm.acaiconcept.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/acaiconcept-caffe/id6762228498',
  },
  'com.fixecrm.birabar.wallet.app': {
    androidPackageId: 'com.fixecrm.birabar.wallet.app',
    iosUrl: 'https://apps.apple.com/br/app/bira-bar/id6797699283',
  },
};

/** App Android genérico de terceiro (Wallet Union) por passbook — legado `appWU`. */
export const WALLET_UNION_PASSBOOK_IDS = new Set(['6365b3ef6e12482b17b9b98b']);

/** Nesses passbooks, iOS recebe o app genérico Fixe CRM em vez do `.pkpass` direto. */
export const GENERIC_FIXE_APP_IOS_PASSBOOK_IDS = new Set([
  '6894b933ff1189fad0f4cb6b',
  '68ae05be7b3383b16717757b',
  '68d302802fd0cc77df638469',
  '68b865e4d6ab9892da149889',
  '69b21f3cff84f75e3bf74ab5',
  '69e660ef08ca603331685121',
]);

export const GENERIC_FIXE_APP_ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.fixecrm.wallet.app';
export const GENERIC_FIXE_APP_IOS_URL = 'https://apps.apple.com/br/app/fidelidade-fixe-crm/id6476572616';

export function androidStoreUrl(packageId: string): string {
  return `https://play.google.com/store/apps/details?id=${packageId}`;
}

export function walletUnionUrl(idPassbook: string, serialNumber: string): string {
  const cardUrl = `${window.location.origin}/bff/public/invite/${idPassbook}/card/apple/${serialNumber}.pkpass`;
  return `https://play.google.com/store/apps/details?id=com.walletunion.wallet&referrer=${cardUrl}`;
}
